export default {
  "h5_associated": {
    "en_US": "Associated",
    "es_ES": "Associated",
    "hi_IN": "Associated",
    "in_ID": "Terkait",
    "ko_KR": "Associated",
    "pt_PT": "Associated",
    "ru_RU": "Associated",
    "vi_VN": "Associated",
    "zh_CN": "已关联",
    "zh_HK": "Associated"
  },
  "h5_cancel": {
    "en_US": "Cancel",
    "es_ES": "Cancel",
    "hi_IN": "Cancel",
    "in_ID": "Membatalkan",
    "ko_KR": "Cancel",
    "pt_PT": "Cancel",
    "ru_RU": "Cancel",
    "vi_VN": "Cancel",
    "zh_CN": "取消",
    "zh_HK": "Cancel"
  },
  "h5_determine": {
    "en_US": "Determine",
    "es_ES": "Determine",
    "hi_IN": "Determine",
    "in_ID": "Menentukan",
    "ko_KR": "Determine",
    "pt_PT": "Determine",
    "ru_RU": "Determine",
    "vi_VN": "Determine",
    "zh_CN": "确认",
    "zh_HK": "Determine"
  },
  "h5_link": {
    "en_US": "Please link game account",
    "es_ES": "Please link game account",
    "hi_IN": "Please link game account",
    "in_ID": "Harap tautkan akun game",
    "ko_KR": "Please link game account",
    "pt_PT": "Please link game account",
    "ru_RU": "Please link game account",
    "vi_VN": "Please link game account",
    "zh_CN": "请绑定游戏角色",
    "zh_HK": "Please link game account"
  },
  "h5_no_data": {
    "en_US": "No relevant records",
    "es_ES": "No relevant records",
    "hi_IN": "No relevant records",
    "in_ID": "Tidak ada catatan yang relevan",
    "ko_KR": "No relevant records",
    "pt_PT": "No relevant records",
    "ru_RU": "No relevant records",
    "vi_VN": "No relevant records",
    "zh_CN": "暂无相关记录",
    "zh_HK": "No relevant records"
  },
  "mall_coins_title": {
    "en_US": "Can M coins",
    "es_ES": "Can M coins",
    "hi_IN": "Can M coins",
    "in_ID": "Bisa M koin",
    "ko_KR": "Can M coins",
    "pt_PT": "Can M coins",
    "ru_RU": "Can M coins",
    "vi_VN": "Can M coins",
    "zh_CN": "获得M币",
    "zh_HK": "Can M coins"
  },
  "mall_day": {
    "en_US": "Day",
    "es_ES": "Day",
    "hi_IN": "Day",
    "in_ID": "Hari",
    "ko_KR": "Day",
    "pt_PT": "Day",
    "ru_RU": "Day",
    "vi_VN": "Day",
    "zh_CN": "天",
    "zh_HK": "Day"
  },
  "mall_days": {
    "en_US": "Days",
    "es_ES": "Days",
    "hi_IN": "Days",
    "in_ID": "Hari",
    "ko_KR": "Days",
    "pt_PT": "Days",
    "ru_RU": "Days",
    "vi_VN": "Days",
    "zh_CN": "每天",
    "zh_HK": "Days"
  },
  "mall_his_text": {
    "en_US": "Exchange history",
    "es_ES": "Exchange history",
    "hi_IN": "Exchange history",
    "in_ID": "Sejarah pertukaran",
    "ko_KR": "Exchange history",
    "pt_PT": "Exchange history",
    "ru_RU": "Exchange history",
    "vi_VN": "Exchange history",
    "zh_CN": "兑换记录",
    "zh_HK": "Exchange history"
  },
  "mall_history_title": {
    "en_US": "Exchange record",
    "es_ES": "Exchange record",
    "hi_IN": "Exchange record",
    "in_ID": "Rekam pertukaran",
    "ko_KR": "Exchange record",
    "pt_PT": "Exchange record",
    "ru_RU": "Exchange record",
    "vi_VN": "Exchange record",
    "zh_CN": "兑换奖励",
    "zh_HK": "Exchange record"
  },
  "mall_limit": {
    "en_US": "Limit",
    "es_ES": "Limit",
    "hi_IN": "Limit",
    "in_ID": "Membatasi",
    "ko_KR": "Limit",
    "pt_PT": "Limit",
    "ru_RU": "Limit",
    "vi_VN": "Limit",
    "zh_CN": "限量",
    "zh_HK": "Limit"
  },
  "mall_login_game": {
    "en_US": "Please log in the game to view",
    "es_ES": "Please log in the game to view",
    "hi_IN": "Please log in the game to view",
    "in_ID": "Silakan masuk ke dalam game untuk melihat",
    "ko_KR": "Please log in the game to view",
    "pt_PT": "Please log in the game to view",
    "ru_RU": "Please log in the game to view",
    "vi_VN": "Please log in the game to view",
    "zh_CN": "请前往游戏查看",
    "zh_HK": "Please log in the game to view"
  },
  "mall_permanent": {
    "en_US": "Permanent",
    "es_ES": "Permanent",
    "hi_IN": "Permanent",
    "in_ID": "Permanen",
    "ko_KR": "Permanent",
    "pt_PT": "Permanent",
    "ru_RU": "Permanent",
    "vi_VN": "Permanent",
    "zh_CN": "持续",
    "zh_HK": "Permanent"
  },
  "mall_send_to": {
    "en_US": "Redeem goods sent to",
    "es_ES": "Redeem goods sent to",
    "hi_IN": "Redeem goods sent to",
    "in_ID": "Tebus barang yang dikirim ke",
    "ko_KR": "Redeem goods sent to",
    "pt_PT": "Redeem goods sent to",
    "ru_RU": "Redeem goods sent to",
    "vi_VN": "Redeem goods sent to",
    "zh_CN": "兑换奖励",
    "zh_HK": "Redeem goods sent to"
  },
  "mall_success": {
    "en_US": "Successful exchange",
    "es_ES": "Successful exchange",
    "hi_IN": "Successful exchange",
    "in_ID": "Pertukaran yang sukses",
    "ko_KR": "Successful exchange",
    "pt_PT": "Successful exchange",
    "ru_RU": "Successful exchange",
    "vi_VN": "Successful exchange",
    "zh_CN": "兑换成功",
    "zh_HK": "Successful exchange"
  },
  "mall_title": {
    "en_US": "M-Store",
    "es_ES": "M-Store",
    "hi_IN": "M-Store",
    "in_ID": "M-Store",
    "ko_KR": "M-Store",
    "pt_PT": "M-Store",
    "ru_RU": "M-Store",
    "vi_VN": "M-Store",
    "zh_CN": "M币商城",
    "zh_HK": "M-Store"
  },
  "mall_unsuccess": {
    "en_US": "Unsuccessful exchange",
    "es_ES": "Unsuccessful exchange",
    "hi_IN": "Unsuccessful exchange",
    "in_ID": "Pertukaran tidak berhasil",
    "ko_KR": "Unsuccessful exchange",
    "pt_PT": "Unsuccessful exchange",
    "ru_RU": "Unsuccessful exchange",
    "vi_VN": "Unsuccessful exchange",
    "zh_CN": "兑换失败",
    "zh_HK": "Unsuccessful exchange"
  },
  "mall_weekly_limit": {
    "en_US": "Weekly limit",
    "es_ES": "Weekly limit",
    "hi_IN": "Weekly limit",
    "in_ID": "Batas mingguan",
    "ko_KR": "Weekly limit",
    "pt_PT": "Weekly limit",
    "ru_RU": "Weekly limit",
    "vi_VN": "Weekly limit",
    "zh_CN": "周限量",
    "zh_HK": "Weekly limit"
  },
  "task_available": {
    "en_US": "Available this week",
    "es_ES": "Available this week",
    "hi_IN": "Available this week",
    "in_ID": "Tersedia minggu ini",
    "ko_KR": "Available this week",
    "pt_PT": "Available this week",
    "ru_RU": "Available this week",
    "vi_VN": "Available this week",
    "zh_CN": "本周可领取",
    "zh_HK": "Available this week"
  },
  "task_check_day": {
    "en_US": "Checked in %s day",
    "es_ES": "Checked in %s day",
    "hi_IN": "Checked in %s day",
    "in_ID": "Check in% s hari",
    "ko_KR": "Checked in %s day",
    "pt_PT": "Checked in %s day",
    "ru_RU": "Checked in %s day",
    "vi_VN": "Checked in %s day",
    "zh_CN": "签到%s天",
    "zh_HK": "Checked in %s day"
  },
  "task_collect": {
    "en_US": "Collect",
    "es_ES": "null",
    "hi_IN": "null",
    "in_ID": "Kumpulkan",
    "ko_KR": "null",
    "pt_PT": "null",
    "ru_RU": "null",
    "vi_VN": "null",
    "zh_CN": "收集",
    "zh_HK": "null"
  },
  "task_complete_btn": {
    "en_US": "To Complete",
    "es_ES": "To Complete",
    "hi_IN": "To Complete",
    "in_ID": "Untuk menyelesaikan",
    "ko_KR": "To Complete",
    "pt_PT": "To Complete",
    "ru_RU": "To Complete",
    "vi_VN": "To Complete",
    "zh_CN": "待完成",
    "zh_HK": "To Complete"
  },
  "task_day": {
    "en_US": "day",
    "es_ES": "day",
    "hi_IN": "day",
    "in_ID": "hari",
    "ko_KR": "day",
    "pt_PT": "day",
    "ru_RU": "day",
    "vi_VN": "day",
    "zh_CN": "天",
    "zh_HK": "day"
  },
  "task_exchange": {
    "en_US": "Exchange",
    "es_ES": "Exchange",
    "hi_IN": "Exchange",
    "in_ID": "Bertukar",
    "ko_KR": "Exchange",
    "pt_PT": "Exchange",
    "ru_RU": "Exchange",
    "vi_VN": "Exchange",
    "zh_CN": "兑换道具",
    "zh_HK": "Exchange"
  },
  "task_no_link": {
    "en_US": "No link A Role Unable to claim",
    "es_ES": "No link A Role Unable to claim",
    "hi_IN": "No link A Role Unable to claim",
    "in_ID": "Tidak ada tautan Peran A Tidak dapat diklaim",
    "ko_KR": "No link A Role Unable to claim",
    "pt_PT": "No link A Role Unable to claim",
    "ru_RU": "No link A Role Unable to claim",
    "vi_VN": "No link A Role Unable to claim",
    "zh_CN": "没有绑定角色无法兑换",
    "zh_HK": "No link A Role Unable to claim"
  },
  "task_received": {
    "en_US": "Received",
    "es_ES": "Received",
    "hi_IN": "Received",
    "in_ID": "Diterima",
    "ko_KR": "Received",
    "pt_PT": "Received",
    "ru_RU": "Received",
    "vi_VN": "Received",
    "zh_CN": "已完成",
    "zh_HK": "Received"
  },
  "task_sign_tommorrow": {
    "en_US": "Sign in tommorrow",
    "es_ES": "Sign in tommorrow",
    "hi_IN": "Sign in tommorrow",
    "in_ID": "Masuk besok",
    "ko_KR": "Sign in tommorrow",
    "pt_PT": "Sign in tommorrow",
    "ru_RU": "Sign in tommorrow",
    "vi_VN": "Sign in tommorrow",
    "zh_CN": "明日签到",
    "zh_HK": "Sign in tommorrow"
  },
  "task_signin": {
    "en_US": "Sign in",
    "es_ES": "Sign in",
    "hi_IN": "Sign in",
    "in_ID": "Masuk",
    "ko_KR": "Sign in",
    "pt_PT": "Sign in",
    "ru_RU": "Sign in",
    "vi_VN": "Sign in",
    "zh_CN": "登录",
    "zh_HK": "Sign in"
  },
  "task_tab_0": {
    "en_US": "Task",
    "es_ES": "Task",
    "hi_IN": "Task",
    "in_ID": "Tugas",
    "ko_KR": "Task",
    "pt_PT": "Task",
    "ru_RU": "Task",
    "vi_VN": "Task",
    "zh_CN": "任务",
    "zh_HK": "Task"
  },
  "task_tab_1": {
    "en_US": "Achievement",
    "es_ES": "Achievement",
    "hi_IN": "Achievement",
    "in_ID": "Prestasi",
    "ko_KR": "Achievement",
    "pt_PT": "Achievement",
    "ru_RU": "Achievement",
    "vi_VN": "Achievement",
    "zh_CN": "成就",
    "zh_HK": "Achievement"
  },
  "task_title": {
    "en_US": "My Task",
    "es_ES": "My Task",
    "hi_IN": "My Task",
    "in_ID": "Tugasku",
    "ko_KR": "My Task",
    "pt_PT": "My Task",
    "ru_RU": "My Task",
    "vi_VN": "My Task",
    "zh_CN": "我的任务",
    "zh_HK": "My Task"
  },
  "task_today": {
    "en_US": "Today",
    "es_ES": "Today",
    "hi_IN": "Today",
    "in_ID": "Hari ini",
    "ko_KR": "Today",
    "pt_PT": "Today",
    "ru_RU": "Today",
    "vi_VN": "Today",
    "zh_CN": "今天",
    "zh_HK": "Today"
  },
  "task_tommorrow": {
    "en_US": "Tommorrow",
    "es_ES": "Tommorrow",
    "hi_IN": "Tommorrow",
    "in_ID": "Besok",
    "ko_KR": "Tommorrow",
    "pt_PT": "Tommorrow",
    "ru_RU": "Tommorrow",
    "vi_VN": "Tommorrow",
    "zh_CN": "明天",
    "zh_HK": "Tommorrow"
  },
  "task_week_title": {
    "en_US": "Task of the week",
    "es_ES": "Task of the week",
    "hi_IN": "Task of the week",
    "in_ID": "Tugas minggu ini",
    "ko_KR": "Task of the week",
    "pt_PT": "Task of the week",
    "ru_RU": "Task of the week",
    "vi_VN": "Task of the week",
    "zh_CN": "每周任务",
    "zh_HK": "Task of the week"
  },
  "textlive_back_to": {
    "en_US": "Latest",
    "es_ES": "Latest",
    "hi_IN": "Latest",
    "in_ID": "Terbaru",
    "ko_KR": "Latest",
    "pt_PT": "Latest",
    "ru_RU": "Latest",
    "vi_VN": "Latest",
    "zh_CN": "最新",
    "zh_HK": "Latest"
  },
  "textlive_pic_title": {
    "en_US": "Picture details",
    "es_ES": "Picture details",
    "hi_IN": "Picture details",
    "in_ID": "Detail gambar",
    "ko_KR": "Picture details",
    "pt_PT": "Picture details",
    "ru_RU": "Picture details",
    "vi_VN": "Picture details",
    "zh_CN": "图片详情",
    "zh_HK": "Picture details"
  },
  "textlive_title": {
    "en_US": "Live text",
    "es_ES": "Live text",
    "hi_IN": "Live text",
    "in_ID": "Teks langsung",
    "ko_KR": "Live text",
    "pt_PT": "Live text",
    "ru_RU": "Live text",
    "vi_VN": "Live text",
    "zh_CN": "文字直播",
    "zh_HK": "Live text"
  }
}